module.exports = __webpack_public_path__ + "a0ccbcf1b49e77f1db4fadbee00e2e73.png";